const system_limit = {
    limit_exceeded: '您已达到系统限制，请联系支持获取协助。',
};
export default Object.freeze(system_limit);
